import { Box, styled, Typography } from "@mui/material";
import { DefaultUrlWeb } from "config/Configuration";

export function Coin({ coin }) {
  return (
    <BoxCoin>
      <img width={"35"} src={DefaultUrlWeb + coin?.coinImageUrl} alt={""} />
      <Typography
        variant="h6"
        display="block"
        color="text.main"
        fontWeight={400}
      >
        {coin?.coinName}
      </Typography>
    </BoxCoin>
  );
}
const BoxCoin = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  img: {
    width: "30px",
    marginRight: theme.spacing(1.3),
    borderRadius: "50%",
  },
}));
export default Coin;
